import { SET_DIRECTIONS } from "@/store/mutation-types";

export default {
  [SET_DIRECTIONS](state, directions) {
    state.directions = {
      ...state.directions,
      ...directions.reduce(
        (map, direction) => ({ ...map, [direction.id]: direction }),
        {}
      )
    };
  }
};
